import React from 'react';
import SignupForm from '../Components/Forms/SignupForm'; // adjust path as needed

const Signup = () => {
  return (
   
          <SignupForm />
  );
};

export default Signup;
